import {ProductInterface} from "../../interfaces/product/ProductInterface";
import {Link} from "react-router-dom";

export default function BundleIncludes({product}: { product: ProductInterface }) {
    const parseItemText = (text: string) => {
        const match = text.match(/\[%(\d+)%\]/);
        if (match) {
            const code = match[1];
            const cleanText = text.replace(/\[%\d+%\]/, '').trim();
            return { code, text: cleanText };
        }
        return { code: null, text };
    }

    if (!product.additional_params?.specification_list_raw?.length) {
        return null;
    }

    return (
        <div className="flex-column flex-lg-row gap-4 justify-content-between prod-pane">
            <div className="d-flex flex-column prod-pane__left">
                <div className="d-flex flex-column prod-pane__right-body">
                    <p className="fw-bold text-uppercase">Комплектация</p>
                    <ul className="d-flex flex-column">
                        {product.additional_params.specification_list_raw.map((item, index) => {
                            const {code, text} = parseItemText(item);
                            return (
                                <li key={index}>
                                    {text.trim() && <span className="t-orange cicle">●</span>}
                                    {code ? (
                                        <Link to={`/catalog/item-by-code/${code}`}
                                              className="t-orange text-decoration-underline">{text}</Link>
                                    ) : (
                                        <span>{text}</span>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
}
